(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     RF Cart Drawer — UX enhancements (non-Balance)
     - Cutoff badge (Rule 4)
     - Delivery date persisted to cart.attributes[Delivery Date] (Rule 1)
     - Gift wrap persisted to cart.attributes[Gift Wrap] (Rule 2)
     - Recently-removed strip with undo (Rule 3)
     Hook points: re-runs on drawer open and after cart-drawer-items
     AJAX updates (Balance re-renders cart-drawer-items inner on qty/remove).
     ========================================================== */
  (function () {
    var STORAGE_KEY = 'rfRecentlyRemoved';
    var TTL_MS = 30 * 60 * 1000; // 30 minutes
    var MAX_RECENT = 3;

    function rfFetchCfg(type) {
      type = type || 'json';
      return {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8',
          'Accept': 'application/' + type
        }
      };
    }

    /* ---------- Cutoff badge ---------- */
    function updateCutoff() {
      var el = document.querySelector('[data-rf-drawer-cutoff]');
      if (!el) return;
      var txt = el.querySelector('[data-rf-drawer-cutoff-text]');
      if (!txt) return;
      var hour = parseInt(el.getAttribute('data-cutoff-hour') || '15', 10);
      var minute = parseInt(el.getAttribute('data-cutoff-minute') || '30', 10);
      var now = new Date();
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0, 0);
      // Clear previous children
      while (txt.firstChild) txt.removeChild(txt.firstChild);
      var strong = document.createElement('strong');
      if (now < cutoff) {
        var diff = cutoff - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        strong.textContent = (h > 0 ? h + 'h ' : '') + m + 'm';
        txt.appendChild(document.createTextNode('Order within '));
        txt.appendChild(strong);
        txt.appendChild(document.createTextNode(' for same-day delivery'));
        el.classList.remove('rf-drawer__cutoff--passed');
      } else {
        var hr12 = ((hour + 11) % 12) + 1;
        var mm = minute < 10 ? '0' + minute : String(minute);
        var ampm = hour >= 12 ? 'PM' : 'AM';
        strong.textContent = 'tomorrow before ' + hr12 + ':' + mm + ' ' + ampm;
        txt.appendChild(document.createTextNode('Next same-day window: '));
        txt.appendChild(strong);
        el.classList.add('rf-drawer__cutoff--passed');
      }
    }
    var cutoffTimer = null;
    function startCutoffLoop() {
      updateCutoff();
      if (cutoffTimer) clearInterval(cutoffTimer);
      cutoffTimer = setInterval(updateCutoff, 60000);
    }

    /* ---------- Delivery date ---------- */
    var deliveryTimer = null;
    function bindDelivery() {
      var input = document.getElementById('CartDrawer-DeliveryDate');
      if (!input || input.dataset.rfBound) return;
      input.dataset.rfBound = '1';
      input.addEventListener('change', function () {
        if (deliveryTimer) clearTimeout(deliveryTimer);
        input.classList.add('rf-drawer__delivery-input--saving');
        deliveryTimer = setTimeout(function () {
          var cfg = rfFetchCfg();
          cfg.body = JSON.stringify({ attributes: { 'Delivery Date': input.value || '' } });
          fetch('/cart/update.js', cfg)
            .catch(function () {})
            .finally(function () {
              input.classList.remove('rf-drawer__delivery-input--saving');
            });
        }, 300);
      });
    }

    /* ---------- Gift wrap ---------- */
    function bindGiftwrap() {
      var box = document.querySelector('[data-rf-drawer-giftwrap]');
      if (!box || box.dataset.rfBound) return;
      box.dataset.rfBound = '1';
      box.addEventListener('change', function () {
        var cfg = rfFetchCfg();
        cfg.body = JSON.stringify({
          attributes: { 'Gift Wrap': box.checked ? 'Yes (+$5)' : '' }
        });
        fetch('/cart/update.js', cfg).catch(function () {});
      });
    }

    /* ---------- Recently removed ---------- */
    function readRecent() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        var now = Date.now();
        return parsed.filter(function (e) {
          return e && e.variant_id && (now - (e.ts || 0)) < TTL_MS;
        });
      } catch (e) { return []; }
    }
    function writeRecent(arr) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_RECENT)));
      } catch (e) {}
    }
    function renderRecent() {
      var wrap = document.querySelector('[data-rf-drawer-recent]');
      var list = document.querySelector('[data-rf-drawer-recent-list]');
      if (!wrap || !list) return;
      var items = readRecent();
      // Clear existing children
      while (list.firstChild) list.removeChild(list.firstChild);
      if (items.length === 0) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      items.forEach(function (it) {
        var chip = document.createElement('div');
        chip.className = 'rf-drawer__recent-chip';
        if (it.image_url) {
          var img = document.createElement('img');
          img.src = it.image_url;
          img.alt = '';
          img.loading = 'lazy';
          chip.appendChild(img);
        }
        var title = document.createElement('span');
        title.className = 'rf-drawer__recent-chip-title';
        title.textContent = it.product_title || 'Item';
        title.title = it.product_title || 'Item';
        chip.appendChild(title);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rf-drawer__recent-chip-add';
        btn.setAttribute('data-variant-id', it.variant_id);
        btn.textContent = 'Add back';
        btn.addEventListener('click', function () {
          var vid = it.variant_id;
          if (!vid) return;
          btn.disabled = true;
          btn.textContent = 'Adding…';
          var cfg = rfFetchCfg();
          cfg.body = JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] });
          fetch('/cart/add.js', cfg)
            .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
            .then(function () {
              var remaining = readRecent().filter(function (e) {
                return String(e.variant_id) !== String(vid);
              });
              writeRecent(remaining);
              renderRecent();
              // Soft reload to let Balance re-render the drawer contents
              window.location.reload();
            })
            .catch(function () {
              btn.disabled = false;
              btn.textContent = 'Add back';
            });
        });
        chip.appendChild(btn);
        list.appendChild(chip);
      });
    }
    function captureRemoval(btn) {
      var li = btn.closest('[id^="CartDrawer-Item-"]');
      if (!li) return;
      var titleEl = li.querySelector('.rf-drawer-item__title');
      var imgEl = li.querySelector('.rf-drawer-item__image img');
      var qtyInput = li.querySelector('[data-quantity-variant-id]');
      var removeInner = btn.querySelector('[data-variant-id]') || btn;
      var variantId =
        (qtyInput && qtyInput.getAttribute('data-quantity-variant-id')) ||
        (removeInner && removeInner.getAttribute && removeInner.getAttribute('data-variant-id'));
      if (!variantId) return;
      var entry = {
        variant_id: String(variantId),
        product_title: titleEl ? titleEl.textContent.trim() : 'Item',
        image_url: imgEl ? imgEl.getAttribute('src') : '',
        ts: Date.now()
      };
      var arr = readRecent().filter(function (e) { return e.variant_id !== entry.variant_id; });
      arr.unshift(entry);
      writeRecent(arr);
    }
    function bindRemovalCapture() {
      var root = document.getElementById('CartDrawer');
      if (!root || root.dataset.rfRemoveBound) return;
      root.dataset.rfRemoveBound = '1';
      // Capture phase so we read the DOM BEFORE Balance removes the line item
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('cart-remove-button, [data-cart-remove]');
        if (!btn) return;
        captureRemoval(btn);
      }, true);
    }

    /* ---------- Wiring ---------- */
    function init() {
      startCutoffLoop();
      bindDelivery();
      bindGiftwrap();
      bindRemovalCapture();
      renderRecent();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-run on drawer open (Balance toggles .active on <cart-drawer>)
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && 'MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.attributeName === 'class' && drawerEl.classList.contains('active')) {
            updateCutoff();
            renderRecent();
          }
        });
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    // Re-bind after Balance re-renders cart-drawer-items contents on AJAX
    var itemsEl = document.querySelector('cart-drawer-items');
    if (itemsEl && 'MutationObserver' in window) {
      new MutationObserver(function () {
        bindRemovalCapture();
      }).observe(itemsEl, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ------------------------------------------------------------
       Qty +/− via cart change API (JSON, UTF-8).

       Targets the line by its 1-based position (data-rf-line, sent as
       { line: n }) rather than Shopify's item.key — key is a hash of
       variant_id + properties that changes on every property write
       (ours or an app's), so caching it in the DOM goes stale as soon
       as any field on the line saves. Position is stable for the
       page's lifetime here: removing a line (Remove link, qty -> 0)
       always hard-reloads the page, so indices never shift under live
       JS without the DOM being rebuilt too.

       Failure handling: Shopify's cart endpoints return 422 with a
       JSON { description } body on errors (e.g. exceeding available
       stock), so r.json() "succeeds" even when the change didn't —
       we must check r.ok explicitly. On failure we revert the input
       to its pre-click value and surface a brief message in the
       per-line status span (same pattern as the gift-field saves).
       On SUCCESS the behavior is unchanged: full page reload so the
       totals, header count, and Bird widget re-render from server
       HTML. Both buttons in the group are disabled while a request
       is in flight (double-click guard) and re-enabled in finally().
       ------------------------------------------------------------ */
    document.querySelectorAll('[data-rf-qty-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var group = btn.parentElement;
        var input = group.querySelector('[data-rf-qty-input]');
        var buttons = group.querySelectorAll('[data-rf-qty-dir]');
        var statusEl = btn.closest('.rf-cart-item__bottom').querySelector('[data-rf-qty-status]');
        var prev = input.value; // captured BEFORE the optimistic bump so a failure can revert
        var v = parseInt(input.value || '1', 10) + parseInt(btn.dataset.rfQtyDir, 10);
        input.value = Math.max(0, v);
        var lineIndex = btn.dataset.rfLine;
        var qty = parseInt(input.value, 10);
        buttons.forEach(function (b) { b.disabled = true; });
        if (statusEl) { statusEl.textContent = ''; statusEl.className = 'rf-cart-item__card-status'; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: qty })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart change failed');
          return r.json();
        }).then(function () {
          window.location.reload();
        }).catch(function () {
          input.value = prev; // roll back the optimistic value
          if (statusEl) {
            statusEl.textContent = 'Couldn’t update quantity — try again';
            statusEl.className = 'rf-cart-item__card-status is-error';
            setTimeout(function () {
              statusEl.textContent = '';
              statusEl.className = 'rf-cart-item__card-status';
            }, 4000);
          }
        }).finally(function () {
          buttons.forEach(function (b) { b.disabled = false; });
        });
      });
    });

    /* ------------------------------------------------------------
       Per-line gift fields (Delivery Date + Card Message) — save on
       blur, and flushed on checkout.

       Shopify's /cart/change.js REPLACES a line's full properties
       object, so we merge: read the live cart, grab this line's
       existing properties, set the one key, then POST the merged set.
       Empty value clears the property (Shopify drops blank properties).

       Delivery Date is additionally mirrored to cart.attributes
       (last-write-wins) to match the PDP, so the Bird Chime delivery
       app — which routes by cart.attributes['Delivery Date'] — sees it.

       Targets the line by its 1-based position (data-rf-line) plus a
       data-rf-variant-id cross-check — NOT Shopify's item.key, which is
       a hash of variant_id + properties and therefore changes on every
       property write (see the qty-button comment above for the full
       reasoning). The variant_id check catches the rare case of another
       tab/app removing a line out from under this one — the fields
       fail loudly instead of silently writing onto whatever product now
       sits at that position.

       saveLineProperty() returns a Promise so the checkout handler can
       AWAIT unsaved edits before navigating — otherwise a customer who
       edits then immediately clicks Checkout could race past the
       in-flight save and lose their input.
       ------------------------------------------------------------ */
    /* Serialize all cart writes. Each save does a read-modify-write on
       the line's full properties object; if two overlap they both read
       the same baseline and the last write clobbers the other (losing a
       field). Chaining every write off the previous one guarantees each
       /cart.js read reflects the prior write. This matters most on the
       checkout flush, which fires date + card saves together. */
    var saveQueue = Promise.resolve();
    function enqueue(task) {
      var run = saveQueue.then(task, task);
      saveQueue = run.catch(function () {}); // keep the chain alive after a failure
      return run;
    }

    function saveLineProperty(field, key, statusEl, mirrorAttrKey) {
      var lineIndex = field.dataset.rfLine;
      var variantId = field.dataset.rfVariantId;
      var val = (field.value || '').trim();
      var original = field.dataset.rfOriginal || '';
      if (val === original) return Promise.resolve(); // nothing changed

      function setStatus(text, cls) {
        if (statusEl) { statusEl.textContent = text; statusEl.className = 'rf-cart-item__card-status ' + cls; }
      }
      setStatus('Saving…', 'is-saving');

      return enqueue(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Look the line up by position, cross-checked against the variant
          // it was rendered with. If it's gone or swapped out (removed in
          // another tab between render and save), fail loudly rather than
          // writing gift data onto a different line.
          var item = cart.items[lineIndex - 1];
          if (!item || String(item.variant_id) !== variantId) throw new Error('line no longer in cart');
          var props = Object.assign({}, item.properties || {});
          if (val) { props[key] = val; } else { delete props[key]; }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json' },
            body: JSON.stringify({ line: lineIndex, properties: props })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('save failed'); return r.json(); })
        .then(function () {
          // Mirror Delivery Date to cart-level attributes for the Bird app.
          // Must check r.ok here too: a 4xx/5xx from /cart/update.js would
          // otherwise resolve and falsely report "✓ Saved" downstream.
          if (mirrorAttrKey && val) {
            var attrs = {}; attrs[mirrorAttrKey] = val;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: attrs })
            }).then(function (r) {
              if (!r.ok) throw new Error('attribute mirror failed');
              return r.json();
            });
          }
        })
        .then(function () {
          field.dataset.rfOriginal = val;
          setStatus('✓ Saved', 'is-saved');
          setTimeout(function () { if (statusEl) statusEl.textContent = ''; }, 2500);
        })
        .catch(function () {
          setStatus('Couldn’t save — try again', 'is-error');
          throw new Error('save failed'); // propagate so checkout flush can react
        });
      });
    }

    function saveCardMessage(ta) {
      return saveLineProperty(ta, 'Card Message', ta.parentElement.querySelector('[data-rf-card-status]'), null);
    }


    /* ------------------------------------------------------------
       Eager save strategy.

       Persist each field as soon as the customer leaves it — card
       message on debounced input + blur, delivery date on change — so
       everything is saved before navigating to checkout. (Delivery vs
       Pickup is chosen at Shopify's checkout, not here, so there's no
       method control to manage in the cart.)
       ------------------------------------------------------------ */
    var cardFields = Array.prototype.slice.call(document.querySelectorAll('[data-rf-card-edit]'));
    cardFields.forEach(function (ta) {
      var debounce;
      ta.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { saveCardMessage(ta).catch(function () {}); }, 700);
      });
      ta.addEventListener('blur', function () {
        clearTimeout(debounce);
        saveCardMessage(ta).catch(function () {});
      });
    });

    /* Generic editable line properties (Recipient, Recipient Phone) —
       same eager save + merge path as the card message. The property key
       is carried on data-rf-prop-edit, so adding another editable field is
       just markup, no new JS. Empty value clears the property. */
    Array.prototype.slice.call(document.querySelectorAll('[data-rf-prop-edit]')).forEach(function (input) {
      var key = input.getAttribute('data-rf-prop-edit');
      var statusEl = input.parentElement.querySelector('[data-rf-prop-status]');
      var debounce;
      input.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { saveLineProperty(input, key, statusEl, null).catch(function () {}); }, 700);
      });
      input.addEventListener('blur', function () {
        clearTimeout(debounce);
        saveLineProperty(input, key, statusEl, null).catch(function () {});
      });
    });

    /* Cart-level note — save on blur via /cart/update.js. JSON keeps
       UTF-8 intact (smart quotes / em-dashes), and saving here rather
       than on the checkout click means it survives Bird's interception.

       defaultValue is the dirty-check baseline: it must ONLY advance
       after a confirmed-ok response. Advancing it on failure would make
       the value === defaultValue check pass on the next blur, so the
       failed save would never be retried and the note silently lost.
       We capture the value at blur time so the baseline records exactly
       what was sent, even if the customer keeps typing while the queued
       request is in flight. */
    var noteField = document.querySelector('[data-rf-cart-note]');
    if (noteField) {
      noteField.addEventListener('blur', function () {
        if (noteField.value === noteField.defaultValue) return;
        var noteVal = noteField.value;
        enqueue(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json' },
            body: JSON.stringify({ note: noteVal })
          }).then(function (r) {
            if (!r.ok) throw new Error('note save failed');
            noteField.defaultValue = noteVal; // confirmed saved
          });
        }).catch(function () {
          /* leave defaultValue stale — the next blur re-runs the save */
        });
      });
    }

    /* ------------------------------------------------------------
       Delivery-date checkout visibility.

       Bird owns the delivery date in cart.attributes['Delivery Date']
       (used for Trexity dispatch + fee), but Shopify's checkout only
       DISPLAYS line-item properties — not cart attributes — so the date
       was invisible at checkout once we dropped the per-item field.

       Fix: mirror Bird's single chosen date into a 'Delivery Date'
       line-item property on EVERY item (display only). This writes to a
       DIFFERENT location than Bird's cart attribute, so there's no
       two-writers race; Bird still owns dispatch. All items get the SAME
       date, so it's still one delivery date per order. The cart hides
       this property (Liquid excludes 'Delivery Date'); checkout shows it.

       Bird sets its input via its own calendar, so we sync reactively:
       a change listener plus a light poll fallback, both routed through
       the serialized enqueue() so writes never overlap.
       ------------------------------------------------------------ */
    (function () {
      var lastSynced = null;
      function birdDateInput() {
        return document.querySelector('#birdchime-slots-box .bcdp-widget-input');
      }
      function syncDeliveryDateToLines() {
        var inp = birdDateInput();
        if (!inp) return;
        var val = (inp.value || '').trim();
        if (!val || val === lastSynced) return;
        lastSynced = val;
        enqueue(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              // Write the date to each line sequentially (one shipment,
              // one date) so every item shows it at checkout.
              // Method-neutral label: the customer picks Ship vs Pickup
              // later at Shopify checkout, which the theme can't read, so
              // "Delivery / Pickup date" is correct for both.
              var KEY = 'Delivery / Pickup date';
              var chain = Promise.resolve();
              cart.items.forEach(function (item) {
                var cur = item.properties || {};
                // Skip only if already correct AND no legacy key to clean.
                if (cur[KEY] === val && !cur['Delivery Date']) return;
                chain = chain.then(function () {
                  var props = Object.assign({}, cur);
                  props[KEY] = val;
                  delete props['Delivery Date']; // remove legacy label if present
                  // Target by stable key, not index — if a line is removed
                  // mid-chain, index targeting would shift onto the wrong item.
                  return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: item.key, properties: props })
                  });
                });
              });
              return chain;
            });
        }).catch(function () { lastSynced = null; }); // allow retry on failure
      }

      // React to Bird's own date input, plus a poll fallback (Bird may set
      // the value programmatically without firing a standard change event).
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('#birdchime-slots-box')) {
          setTimeout(syncDeliveryDateToLines, 300);
        }
      });
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('#birdchime-slots-box')) {
          setTimeout(syncDeliveryDateToLines, 800);
        }
      });
      setInterval(syncDeliveryDateToLines, 2000); // catch Bird's default + calendar picks
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var openBtn = document.querySelector('[data-rf-open-filters]');
    var closeBtn = document.querySelector('[data-rf-close-filters]');
    var backdrop = document.querySelector('[data-rf-filter-backdrop]');
    function open() { document.body.classList.add('rf-filters-open'); }
    function close() { document.body.classList.remove('rf-filters-open'); }
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    // ESC to close drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Parse "HH:MM-HH:MM" or "Closed" / empty → returns { open: "HH:MM", close: "HH:MM" } or null.
    function parseRange(str) {
      if (!str) return null;
      var trimmed = String(str).trim();
      if (!trimmed || /closed/i.test(trimmed)) return null;
      // Accept both hyphen and en-dash.
      var parts = trimmed.split(/\s*[-–]\s*/);
      if (parts.length !== 2) return null;
      var open = normTime(parts[0]);
      var close = normTime(parts[1]);
      if (open === null || close === null) return null;
      return { open: open, close: close };
    }

    // Normalize "12:00", "9:00", "9" → minutes-since-midnight integer, or null.
    function normTime(t) {
      if (!t) return null;
      var m = String(t).trim().match(/^(\d{1,2})(?::(\d{2}))?/);
      if (!m) return null;
      var h = parseInt(m[1], 10);
      var min = m[2] ? parseInt(m[2], 10) : 0;
      if (isNaN(h) || isNaN(min) || h < 0 || h > 24 || min < 0 || min > 59) return null;
      return h * 60 + min;
    }

    function minsToLabel(mins) {
      var h = Math.floor(mins / 60) % 24;
      var suffix = h >= 12 ? 'PM' : 'AM';
      var h12 = h % 12 === 0 ? 12 : h % 12;
      var m = mins % 60;
      if (m === 0) return h12 + ' ' + suffix;
      return h12 + ':' + (m < 10 ? '0' + m : m) + ' ' + suffix;
    }

    function minsToCountdown(mins) {
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      if (h <= 0) return m + 'm';
      if (m === 0) return h + 'h';
      return h + 'h ' + m + 'm';
    }

    var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var DAY_LABEL = { sun: 'Sunday', mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday' };

    function updateCard(card) {
      var now = new Date(); // Uses visitor's local browser time — acceptable for a Toronto single-location store.
      var todayIdx = now.getDay();
      var todayKey = DAYS[todayIdx];
      var nowMins = now.getHours() * 60 + now.getMinutes();

      var todays = parseRange(card.getAttribute('data-hours-' + todayKey));
      var state = 'closed';
      var statusText = '';

      if (todays) {
        if (nowMins >= todays.open && nowMins < todays.close) {
          state = 'open';
          var untilClose = todays.close - nowMins;
          statusText = 'Open · closes in ' + minsToCountdown(untilClose);
        } else if (nowMins < todays.open) {
          var untilOpen = todays.open - nowMins;
          if (untilOpen <= 120) {
            state = 'soon';
            statusText = 'Opens in ' + minsToCountdown(untilOpen);
          } else {
            state = 'closed';
            statusText = 'Closed · opens today at ' + minsToLabel(todays.open);
          }
        } else {
          // after close → find next open day
          state = 'closed';
          var next = findNextOpen(card, todayIdx);
          if (next) {
            if (next.dayOffset === 1) {
              statusText = 'Closed · opens tomorrow at ' + minsToLabel(next.open);
            } else {
              statusText = 'Closed · opens ' + DAY_LABEL[next.dayKey] + ' at ' + minsToLabel(next.open);
            }
          } else {
            statusText = 'Closed';
          }
        }
      } else {
        // today is closed entirely
        var next2 = findNextOpen(card, todayIdx);
        if (next2) {
          if (next2.dayOffset === 1) {
            statusText = 'Closed · opens tomorrow at ' + minsToLabel(next2.open);
          } else {
            statusText = 'Closed · opens ' + DAY_LABEL[next2.dayKey] + ' at ' + minsToLabel(next2.open);
          }
        } else {
          statusText = 'Closed';
        }
      }

      card.setAttribute('data-state', state);
      var statusEl = card.querySelector('[data-rf-hours-status]');
      if (statusEl) statusEl.textContent = statusText;

      // Highlight today's row
      var rows = card.querySelectorAll('.rf-hours-card__row');
      rows.forEach(function (row) {
        if (row.getAttribute('data-day') === todayKey) {
          row.setAttribute('data-today', 'true');
        } else {
          row.removeAttribute('data-today');
        }
      });
    }

    function findNextOpen(card, fromIdx) {
      for (var i = 1; i <= 7; i++) {
        var idx = (fromIdx + i) % 7;
        var key = DAYS[idx];
        var range = parseRange(card.getAttribute('data-hours-' + key));
        if (range) return { dayOffset: i, dayKey: key, open: range.open };
      }
      return null;
    }

    function init() {
      var cards = document.querySelectorAll('[data-rf-hours]');
      if (!cards.length) return;
      cards.forEach(updateCard);
      // Refresh every minute so countdown stays live.
      setInterval(function () { cards.forEach(updateCard); }, 60000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-customer-addresses"] && !Shopify.designMode) return;
  try {
    
  /*
   * Country → province cascade.
   * Shopify exposes window.Shopify.CountryProvinceSelector (and Shopify.Countries)
   * on customer-facing pages once customer.js loads. Because we're replacing
   * main-addresses.liquid (which loads customer.js), that dependency is no
   * longer guaranteed — so we provide a self-contained selector that works
   * against Shopify.Countries if available, and falls back to a text input
   * for province if the country data blob is missing.
   *
   * Each <select class="rf-addresses__country"> references a province target
   * and container by id via data- attributes. On change, we rebuild the
   * province <select> options; if the country has no provinces we hide the
   * province container entirely (Shopify accepts a missing province).
   */
  (function () {
    var countrySelects = document.querySelectorAll('.rf-addresses__country');
    if (!countrySelects.length) return;

    function buildProvinces(countrySelect) {
      var targetId = countrySelect.getAttribute('data-province-target');
      var containerId = countrySelect.getAttribute('data-province-container');
      var target = targetId ? document.getElementById(targetId) : null;
      var container = containerId ? document.getElementById(containerId) : null;
      if (!target || !container) return;

      var defaultCountry = countrySelect.getAttribute('data-default');
      var defaultProvince = target.getAttribute('data-default') || '';

      // Pick current country option
      var selectedOption = countrySelect.options[countrySelect.selectedIndex];
      if (!selectedOption) return;

      var raw = selectedOption.getAttribute('data-provinces');
      var provinces = [];
      if (raw) {
        try { provinces = JSON.parse(raw); } catch (e) { provinces = []; }
      }

      // Clear target
      while (target.firstChild) target.removeChild(target.firstChild);

      if (!provinces.length) {
        container.style.display = 'none';
        return;
      }

      container.style.display = '';
      provinces.forEach(function (pair) {
        var opt = document.createElement('option');
        opt.value = pair[0];
        opt.textContent = pair[1];
        if (pair[0] === defaultProvince || pair[1] === defaultProvince) {
          opt.selected = true;
        }
        target.appendChild(opt);
      });
    }

    countrySelects.forEach(function (sel) {
      // Set initial country to data-default if present
      var defaultCountry = sel.getAttribute('data-default');
      if (defaultCountry) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === defaultCountry) {
            sel.selectedIndex = i;
            break;
          }
        }
      }
      buildProvinces(sel);
      sel.addEventListener('change', function () { buildProvinces(sel); });
    });
  })();

  /*
   * FEATURE 1 — Address label picker.
   * Each .rf-label-picker has a group of <button> pills and a hidden
   * custom-label text input. Selecting a pill writes its value into
   * the form's hidden [data-company-input] (the `company` field — see
   * note in CLAUDE.md / task: Shopify's customer address has no
   * dedicated label field, so we reuse `company` as a proxy. It's
   * shown by Shopify's formatted-address output by default, which
   * is actually useful for delivery instructions). Custom selection
   * reveals a 20-char input whose value overrides the company field
   * live as the user types.
   *
   * On edit forms we pre-select the pill matching address.company if
   * it matches one of the predefined labels; otherwise "Custom" is
   * pre-selected and the existing company value is loaded into the
   * custom input.
   */
  (function () {
    var pickers = document.querySelectorAll('[data-label-picker]');
    if (!pickers.length) return;

    pickers.forEach(function (picker) {
      var pills = picker.querySelectorAll('.rf-label-pill');
      var customWrap = picker.querySelector('[data-label-custom]');
      var customInput = picker.querySelector('[data-label-custom-input]');
      // company input lives in the SAME form — find it relative to picker's form
      var form = picker.closest('form');
      if (!form) return;
      var companyInput = form.querySelector('[data-company-input]');
      if (!companyInput) return;

      function setCompanyValue(v) { companyInput.value = v || ''; }

      function selectPill(pill, suppressWrite) {
        pills.forEach(function (p) { p.setAttribute('aria-checked', 'false'); });
        pill.setAttribute('aria-checked', 'true');
        var value = pill.getAttribute('data-label-value') || '';
        var isCustom = value.toLowerCase() === 'custom';
        if (customWrap) {
          if (isCustom) {
            customWrap.hidden = false;
            if (!suppressWrite) {
              // When user actively picks Custom, start with current custom input value
              setCompanyValue(customInput && customInput.value ? customInput.value : '');
              if (customInput) customInput.focus();
            }
          } else {
            customWrap.hidden = true;
            if (!suppressWrite) setCompanyValue(value);
          }
        } else if (!suppressWrite) {
          setCompanyValue(value);
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () { selectPill(pill, false); });
      });

      if (customInput) {
        customInput.addEventListener('input', function () {
          // Only write if Custom is currently selected
          var active = picker.querySelector('.rf-label-pill[aria-checked="true"]');
          if (active && (active.getAttribute('data-label-value') || '').toLowerCase() === 'custom') {
            setCompanyValue(customInput.value);
          }
        });
      }

      // Pre-select based on existing company value (edit form) without overwriting it
      var current = (picker.getAttribute('data-current-label') || companyInput.value || '').trim();
      if (current) {
        var matched = null;
        pills.forEach(function (pill) {
          var v = (pill.getAttribute('data-label-value') || '').trim();
          if (v.toLowerCase() === current.toLowerCase() && v.toLowerCase() !== 'custom') {
            matched = pill;
          }
        });
        if (matched) {
          selectPill(matched, true);
        } else {
          // Fall back to Custom pill
          var customPill = null;
          pills.forEach(function (pill) {
            if ((pill.getAttribute('data-label-value') || '').toLowerCase() === 'custom') {
              customPill = pill;
            }
          });
          if (customPill) {
            selectPill(customPill, true);
            if (customInput) customInput.value = current;
            if (customWrap) customWrap.hidden = false;
          }
        }
      }
    });
  })();

  /*
   * FEATURE 2 — Duplicate-address detection on new-address submit.
   * Reads the JSON blob from <script data-existing-addresses>, then
   * intercepts #rf-new-address-form submit. If the entered address1
   * + zip (normalized) matches an existing row, shows the confirm
   * modal. Clicking "Yes, save anyway" sets a sentinel flag and
   * re-submits; "Cancel" dismisses.
   */
  (function () {
    var section = document.querySelector('[data-rf-addresses]');
    if (!section) return;
    if (section.getAttribute('data-enable-duplicate') !== 'true') return;

    var jsonEl = section.querySelector('[data-existing-addresses]');
    var modal = section.querySelector('[data-dup-modal]');
    var form = section.querySelector('#rf-new-address-form');
    if (!jsonEl || !modal || !form) return;

    var existing = [];
    try { existing = JSON.parse(jsonEl.textContent || '[]'); } catch (e) { existing = []; }
    if (!existing.length) return;

    function norm(s) {
      return (s || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
    }

    function findDup() {
      var a1 = form.querySelector('input[name="address[address1]"]');
      var zip = form.querySelector('input[name="address[zip]"]');
      if (!a1 || !zip) return null;
      var key1 = norm(a1.value);
      var key2 = norm(zip.value);
      if (!key1 || !key2) return null;
      for (var i = 0; i < existing.length; i++) {
        if (norm(existing[i].address1) === key1 && norm(existing[i].zip) === key2) {
          return existing[i];
        }
      }
      return null;
    }

    var bypass = false;
    form.addEventListener('submit', function (e) {
      if (bypass) return; // user confirmed; let it through
      var dup = findDup();
      if (!dup) return;
      e.preventDefault();
      var labelEl = modal.querySelector('[data-dup-label]');
      if (labelEl) {
        var lbl = (dup.company && dup.company.trim()) ? dup.company.trim() : 'an existing address';
        labelEl.textContent = lbl;
      }
      modal.hidden = false;
    });

    modal.querySelectorAll('[data-dup-cancel]').forEach(function (btn) {
      btn.addEventListener('click', function () { modal.hidden = true; });
    });
    var confirmBtn = modal.querySelector('[data-dup-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        bypass = true;
        modal.hidden = true;
        // Use requestSubmit if available so form validation still runs
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }

    // Escape closes the modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) modal.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-customer-form"]) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest('.rf-customer-form');
    if (!root) {
      var all = document.querySelectorAll('.rf-customer-form');
      root = all[all.length - 1];
    }
    if (!root) return;

    // ── Forgot-password disclosure auto-open ─────────────────────
    var details = root.querySelector('.rf-customer-form__recover');
    if (details) {
      var shouldOpen = window.location.hash === '#recover'
        || details.querySelector('.rf-customer-form__errors')
        || details.querySelector('.rf-customer-form__success');
      if (shouldOpen) {
        details.setAttribute('open', '');
        if (window.location.hash === '#recover') {
          details.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      document.querySelectorAll('a[href="#recover"]').forEach(function (a) {
        a.addEventListener('click', function () {
          details.setAttribute('open', '');
        });
      });
    }

    // ── Show/hide password toggle ────────────────────────────────
    root.querySelectorAll('[data-rf-toggle-pw]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.rf-field__input-wrap');
        if (!wrap) return;
        var input = wrap.querySelector('input');
        if (!input) return;
        var showing = input.type === 'text';
        input.type = showing ? 'password' : 'text';
        btn.setAttribute('aria-pressed', showing ? 'false' : 'true');
        btn.setAttribute('aria-label', showing ? 'Show password' : 'Hide password');
      });
    });

    // ── Password strength meter (custom, lightweight, no zxcvbn) ─
    function scorePassword(pw) {
      if (!pw || pw.length < 8) return 0;
      var score = 0;
      if (/[a-z]/.test(pw)) score++;
      if (/[A-Z]/.test(pw)) score++;
      if (/\d/.test(pw)) score++;
      if (/[^A-Za-z0-9]/.test(pw)) score++;
      // bonus for length
      if (pw.length >= 12) score++;
      // clamp to 1..4
      if (score < 1) return 1;
      if (score > 4) return 4;
      return score;
    }
    var LABELS = ['Too short', 'Weak', 'Fair', 'Good', 'Strong'];

    root.querySelectorAll('[data-rf-pw-target]').forEach(function (input) {
      var field = input.closest('.rf-field');
      if (!field) return;
      var meter = field.querySelector('[data-rf-pw-meter]');
      var label = field.querySelector('[data-rf-pw-label]');
      if (!meter && !label) return;

      input.addEventListener('input', function () {
        var s = scorePassword(input.value);
        if (meter) {
          meter.setAttribute('data-score', String(s));
          meter.setAttribute('aria-valuenow', String(s));
        }
        if (label) {
          label.textContent = LABELS[s] || LABELS[0];
        }
      });
    });

    // ── Inline field validation ──────────────────────────────────
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function validateField(field) {
      var kind = field.getAttribute('data-rf-validate');
      var input = field.querySelector('input');
      var errEl = field.querySelector('[data-rf-field-error]');
      if (!input || !errEl) return true;

      var val = input.value;
      var msg = '';

      switch (kind) {
        case 'email':
          if (!val) msg = 'Required';
          else if (!EMAIL_RE.test(val)) msg = 'Enter a valid email address';
          break;
        case 'password-login':
          if (!val) msg = 'Required';
          break;
        case 'password-new':
          if (!val) msg = 'Required';
          else if (val.length < 8) msg = 'Must be at least 8 characters';
          break;
        case 'password-confirm':
          var matchSel = field.getAttribute('data-rf-match');
          var other = matchSel ? root.querySelector(matchSel) : null;
          if (!val) msg = 'Required';
          else if (other && other.value !== val) msg = "Passwords don't match";
          break;
        case 'required':
          if (!val.trim()) msg = 'Required';
          break;
      }

      if (msg) {
        input.setAttribute('aria-invalid', 'true');
        errEl.textContent = msg;
        errEl.hidden = false;
        return false;
      } else {
        input.removeAttribute('aria-invalid');
        errEl.textContent = '';
        errEl.hidden = true;
        return true;
      }
    }

    var validationOn = root.getAttribute('data-rf-show-validation') !== 'false';
    if (validationOn) {
      root.querySelectorAll('[data-rf-validate]').forEach(function (field) {
        var input = field.querySelector('input');
        if (!input) return;
        var touched = false;
        input.addEventListener('blur', function () {
          touched = true;
          validateField(field);
        });
        input.addEventListener('input', function () {
          if (touched) validateField(field);
          // live-validate the other confirm when the source changes
          var matchers = root.querySelectorAll('[data-rf-match="#' + input.id + '"]');
          matchers.forEach(function (f) {
            var i = f.querySelector('input');
            if (i && i.value) validateField(f);
          });
        });
      });

      // Block submit if any field invalid
      root.querySelectorAll('form').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          var fields = form.querySelectorAll('[data-rf-validate]');
          var firstBad = null;
          fields.forEach(function (f) {
            var ok = validateField(f);
            if (!ok && !firstBad) firstBad = f;
          });
          if (firstBad) {
            e.preventDefault();
            var badInput = firstBad.querySelector('input');
            if (badInput) badInput.focus();
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-delivery-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    var LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    var TILE_URL = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
    var TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';
    var STUDIO_EMAIL = 'rainbowfloralbloor@gmail.com';

    /*
      Captured Leaflet reference — NOT the same as window.L. Other theme
      bundles (e.g. rf-lenis.min.js, whose minified export also lands on
      window.L) can load after Leaflet and stomp the global, so every call
      below uses this captured reference instead of the bare `L` global.
      leafletReady tracks readiness ourselves rather than trusting
      window.L's truthiness or a script's 'load' event (which only fires
      once — on a revisit the tag already exists and already loaded, so
      re-attaching a 'load' listener would wait forever).
    */
    var Leaflet = null;
    var leafletReady = false;

    function onLeafletLoaded(cb) {
      leafletReady = true;
      Leaflet = window.L;
      cb();
    }

    function loadLeaflet(cb) {
      if (leafletReady) return cb();
      if (!document.querySelector('link[data-rf-leaflet]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = LEAFLET_CSS;
        link.setAttribute('data-rf-leaflet', '');
        document.head.appendChild(link);
      }
      var existing = document.querySelector('script[data-rf-leaflet]');
      if (existing) {
        existing.addEventListener('load', function () { onLeafletLoaded(cb); });
        return;
      }
      var s = document.createElement('script');
      s.src = LEAFLET_JS;
      s.async = true;
      s.setAttribute('data-rf-leaflet', '');
      s.onload = function () { onLeafletLoaded(cb); };
      document.head.appendChild(s);
    }

    function normalizePostal(value) {
      // Strict allowlist: A-Z and 0-9 only.
      return (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    // Format postal code as a carrier-friendly address string. e.g.
    // "M5V1A1" → "M5V 1A1, Toronto, ON, Canada"
    function postalAsAddress(pc) {
      var clean = normalizePostal(pc);
      var spaced = clean.length >= 6 ? clean.slice(0, 3) + ' ' + clean.slice(3, 6) : clean;
      return spaced + ', Toronto, ON, Canada';
    }

    function lookupZone(postal, zones) {
      var fsa = normalizePostal(postal).slice(0, 3);
      if (fsa.length < 3) return null;
      for (var i = 0; i < zones.length; i++) {
        var prefixes = (zones[i].prefixes || '').split(',').map(function (p) { return p.trim().toUpperCase(); }).filter(Boolean);
        for (var j = 0; j < prefixes.length; j++) {
          if (fsa.indexOf(prefixes[j]) === 0) {
            return zones[i];
          }
        }
      }
      return null;
    }

    function el(tag, opts) {
      var node = document.createElement(tag);
      if (!opts) return node;
      if (opts.className) node.className = opts.className;
      if (opts.text != null) node.textContent = opts.text;
      if (opts.attrs) {
        Object.keys(opts.attrs).forEach(function (k) { node.setAttribute(k, opts.attrs[k]); });
      }
      if (opts.children) {
        opts.children.forEach(function (c) { if (c) node.appendChild(c); });
      }
      return node;
    }

    function clearChildren(node) {
      while (node.firstChild) node.removeChild(node.firstChild);
    }

    function formatCents(cents, currency) {
      if (cents == null || isNaN(cents)) return null;
      try {
        return new Intl.NumberFormat('en-CA', {
          style: 'currency',
          currency: currency || 'CAD'
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function formatDistance(meters) {
      if (meters == null || isNaN(meters)) return null;
      var km = meters / 1000;
      return km < 10 ? km.toFixed(1) + ' km' : Math.round(km) + ' km';
    }

    function formatETA(isoString) {
      if (!isoString) return null;
      var d = new Date(isoString);
      if (isNaN(d.getTime())) return null;
      var sameDay = (new Date()).toDateString() === d.toDateString();
      var time = d.toLocaleTimeString('en-CA', { hour: 'numeric', minute: '2-digit', hour12: true });
      if (sameDay) return 'today by ' + time;
      var dayName = d.toLocaleDateString('en-CA', { weekday: 'short' });
      return dayName + ' by ' + time;
    }

    /*
      Haversine great-circle distance in km between two lat/lng points.
      Used to map a clicked map location to one of the radial zones
      (Toronto Core / GTA / Outside) so the legend dims to the right
      zone — the live-quote API's response doesn't carry our zone
      semantics so we resolve them here.
    */
    function haversineKm(lat1, lng1, lat2, lng2) {
      var R = 6371; // earth radius km
      var toRad = function (d) { return d * Math.PI / 180; };
      var dLat = toRad(lat2 - lat1);
      var dLng = toRad(lng2 - lng1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    /*
      Pick the smallest zone (by radius_km) whose radius covers the
      given crow-flies distance. Zones must be sorted ascending by
      radius, which we ensure inside the section's init.
    */
    function zoneForDistance(km, zonesAsc) {
      for (var i = 0; i < zonesAsc.length; i++) {
        if (km <= (zonesAsc[i].radius_km || 0)) return zonesAsc[i];
      }
      return zonesAsc[zonesAsc.length - 1] || null;
    }

    async function fetchQuote(quoteApiUrl, requestBody) {
      var r = await fetch(quoteApiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });
      var data = null;
      try { data = await r.json(); } catch (e) {}
      if (!r.ok) {
        var err = new Error('quote-failed-' + r.status);
        err.payload = data;
        throw err;
      }
      return data;
    }

    function initSection(section) {
      var mapEl = section.querySelector('[data-rf-map]');
      var form = section.querySelector('[data-rf-pc-form]');
      var input = section.querySelector('[data-rf-pc-input]');
      var submitBtn = form ? form.querySelector('button[type=submit]') : null;
      var result = section.querySelector('[data-rf-pc-result]');
      var legendItems = section.querySelectorAll('[data-rf-zone-name]');

      if (!mapEl) return;

      var lat = parseFloat(mapEl.dataset.studioLat);
      var lng = parseFloat(mapEl.dataset.studioLng);
      var studioLabel = mapEl.dataset.studioLabel || 'Studio';
      var quoteApiUrl = mapEl.dataset.quoteApiUrl || '';
      var clickEnabled = mapEl.dataset.clickEnabled !== 'false';
      var zones = [];
      try {
        zones = JSON.parse(mapEl.dataset.zones || '[]');
      } catch (e) {
        console.warn('[rf-delivery-map] Could not parse zones JSON', e);
      }

      var sortedForRender = zones.slice().sort(function (a, b) {
        return (b.radius_km || 0) - (a.radius_km || 0);
      });
      // Ascending sort for zoneForDistance() matching — smallest radius first.
      var sortedAsc = zones.slice().sort(function (a, b) {
        return (a.radius_km || 0) - (b.radius_km || 0);
      });

      var dropPin = null;
      // Per-section quote cache — keyed by address ('a:'…) or rounded
      // lat/lng ('g:'…). Repeat lookups of the same point skip the network.
      var quoteCache = Object.create(null);
      // Monotonic token so an out-of-order quote response from an earlier
      // click can't overwrite the panel for a newer one.
      var lookupSeq = 0;
      var activeLookupMethod = 'unknown';

      function trackDelivery(eventName, data) {
        if (typeof window.__rfGeoTrack !== 'function') return;
        window.__rfGeoTrack(eventName, Object.assign({
          lookup_method: activeLookupMethod
        }, data || {}));
      }

      function distanceBucket(meters) {
        if (meters == null || isNaN(meters)) return '';
        var km = meters / 1000;
        if (km <= 3) return '0-3km';
        if (km <= 6) return '3-6km';
        if (km <= 12) return '6-12km';
        if (km <= 22) return '12-22km';
        return '22km-plus';
      }

      function feeBucket(cents) {
        if (cents == null || isNaN(cents)) return '';
        var dollars = cents / 100;
        if (dollars <= 10) return '0-10';
        if (dollars <= 15) return '10-15';
        if (dollars <= 25) return '15-25';
        return '25-plus';
      }

      function dimLegend(activeName) {
        legendItems.forEach(function (li) {
          if (!activeName || li.dataset.rfZoneName === activeName) {
            li.classList.remove('is-dim');
          } else {
            li.classList.add('is-dim');
          }
        });
      }

      function highlightZone(zoneName) {
        if (!section._rfCircles) return;
        Object.keys(section._rfCircles).forEach(function (name) {
          var c = section._rfCircles[name];
          if (zoneName && name === zoneName) {
            c.setStyle({ fillOpacity: 0.42, weight: 2.5, opacity: 1 });
          } else {
            c.setStyle({ fillOpacity: 0.10, weight: 1.5, opacity: 0.6 });
          }
        });
      }

      /*
        Mobile UX: after any interaction (postal code submit, map
        click, geolocation), scroll the result panel into view.
        Without this, a customer who clicks the map (below the
        calculator on mobile) has to manually scroll back up to
        see what changed. Only runs on ≤900px viewports where the
        layout is stacked. Uses 'nearest' so the panel snaps under
        the sticky header instead of flying to dead-centre.
      */
      function scrollResultIntoView() {
        if (window.innerWidth > 900) return;
        if (!result) return;
        // Small delay so the DOM update settles before scrolling
        requestAnimationFrame(function () {
          result.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      function renderQuote(q, hintZone) {
        if (!result) return;
        // If the live-quote API says out-of-zone but our radii say
        // in-zone, trust our radii — the customer is in the green
        // circle, they should see the zone rate, not a "we don't
        // deliver here" message.
        if (q && q.out_of_zone) {
          if (hintZone) { renderZoneFallback(hintZone); return; }
          renderMiss();
          return;
        }
        result.className = 'rf-delivery-map__result is-found';
        clearChildren(result);

        /*
          Lead with the zone label (Toronto Core / Greater Toronto / etc.)
          when we have a hint, so the customer's first line of sight on
          the result panel matches the zone they see highlighted on the
          map. The live-quote API's own `name` is intentionally hidden
          from the rendered UI — customers don't need to know which
          fulfillment partner we use.
        */
        if (hintZone && hintZone.name) {
          result.appendChild(el('span', { className: 'rf-delivery-map__result-name', text: hintZone.name }));
        } else if (q && q.name) {
          result.appendChild(el('span', { className: 'rf-delivery-map__result-name', text: q.name }));
        }

        var fee = formatCents(q && q.total_cents, q && q.currency);
        if (fee) {
          result.appendChild(el('div', { className: 'rf-delivery-map__result-fee', text: fee }));
        }

        // Show the road distance (useful context — "you're 4 km from
        // our studio") but NOT the live-quote API's courier ETA. That
        // ETA assumes immediate dispatch — for a florist with prep
        // time and a 12 PM – 8 PM window, surfacing a precise
        // "arrives today by 6:47 PM" is misleading. We use the zone's
        // own cut-off note ("Same-day if ordered by 3:30 PM…") which
        // is the operationally accurate answer.
        var dist = formatDistance(q && q.distance_meters);
        if (dist) {
          result.appendChild(el('div', { className: 'rf-delivery-map__result-meta', text: dist + ' from our studio' }));
        }

        if (hintZone && hintZone.note) {
          result.appendChild(el('div', { className: 'rf-delivery-map__result-meta', text: hintZone.note }));
        }

        result.appendChild(el('div', {
          className: 'rf-delivery-map__result-meta',
          text: 'Delivery between 12 PM – 8 PM. Final fee confirmed at checkout.'
        }));

        // Dim the legend to the hint zone (or fall back to a name
        // match against the carrier response if no hint was passed).
        var matchedName = null;
        if (hintZone && hintZone.name) {
          matchedName = hintZone.name;
        } else if (q && q.name) {
          for (var i = 0; i < zones.length; i++) {
            if (zones[i].name && q.name.toLowerCase().indexOf(zones[i].name.toLowerCase()) !== -1) {
              matchedName = zones[i].name;
              break;
            }
          }
        }
        if (matchedName) {
          dimLegend(matchedName);
          highlightZone(matchedName);
        } else {
          dimLegend(null);
          highlightZone(null);
        }
        trackDelivery('rf_delivery_quote_result', {
          quote_status: 'exact_quote',
          zone_name: matchedName || (hintZone && hintZone.name) || '',
          distance_bucket: distanceBucket(q && q.distance_meters),
          fee_bucket: feeBucket(q && q.total_cents)
        });
        trackDelivery('rf_delivery_exact_quote_success', {
          zone_name: matchedName || (hintZone && hintZone.name) || '',
          distance_bucket: distanceBucket(q && q.distance_meters),
          fee_bucket: feeBucket(q && q.total_cents)
        });
        // No scroll here: the instant zone estimate already scrolled the
        // panel into view, and this exact-fee render replaces it in place.
        // Re-scrolling on the async refine would yank a mobile reader who
        // has started scrolling away.
      }

      /*
        Render a zone's typical-range estimate. With opts.refining, append a
        live "getting your exact rate…" indicator instead of the static
        checkout note — used as the instant first paint before the precise
        quote returns and replaces this panel.
      */
      function renderZoneFallback(zone, opts) {
        if (!result) return;
        var refining = !!(opts && opts.refining);
        result.className = 'rf-delivery-map__result is-found';
        clearChildren(result);
        result.appendChild(el('span', { className: 'rf-delivery-map__result-name', text: zone.name }));
        if (zone.rate) {
          result.appendChild(el('div', { className: 'rf-delivery-map__result-fee', text: zone.rate }));
        }
        if (zone.note) {
          result.appendChild(el('div', { className: 'rf-delivery-map__result-meta', text: zone.note }));
        }
        if (refining) {
          result.appendChild(el('div', {
            className: 'rf-delivery-map__result-refining',
            children: [
              el('span', { className: 'rf-delivery-map__spinner', attrs: { 'aria-hidden': 'true' } }),
              el('span', { text: 'Getting your exact rate…' })
            ]
          }));
        } else {
          result.appendChild(el('div', {
            className: 'rf-delivery-map__result-meta',
            text: 'Exact fee shown at checkout once we have your full address.'
          }));
        }
        dimLegend(zone.name);
        highlightZone(zone.name);
        trackDelivery(refining ? 'rf_delivery_quote_pending' : 'rf_delivery_quote_result', {
          quote_status: refining ? 'zone_estimate_refining' : 'zone_estimate',
          zone_name: zone.name || '',
          distance_bucket: '',
          fee_bucket: zone.rate || ''
        });
        scrollResultIntoView();
      }

      function renderMiss(distKm) {
        if (!result) return;
        result.className = 'rf-delivery-map__result is-miss';
        clearChildren(result);
        result.appendChild(el('span', { className: 'rf-delivery-map__result-name', text: 'Outside our delivery range' }));
        if (distKm != null && !isNaN(distKm)) {
          var rounded = distKm < 10 ? distKm.toFixed(1) : Math.round(distKm);
          result.appendChild(el('div', {
            className: 'rf-delivery-map__result-meta',
            text: 'That spot is about ' + rounded + ' km from our studio — past our furthest zone.'
          }));
        }
        var meta = el('div', { className: 'rf-delivery-map__result-meta' });
        meta.appendChild(document.createTextNode('We can still help — email '));
        meta.appendChild(el('a', { text: STUDIO_EMAIL, attrs: { href: 'mailto:' + STUDIO_EMAIL } }));
        meta.appendChild(document.createTextNode(' for a custom quote.'));
        result.appendChild(meta);
        dimLegend(null);
        highlightZone(null);
        trackDelivery('rf_delivery_quote_result', {
          quote_status: 'out_of_zone',
          zone_name: '',
          distance_bucket: distKm == null || isNaN(distKm) ? '' : distanceBucket(distKm * 1000),
          fee_bucket: ''
        });
        scrollResultIntoView();
      }

      function renderTooShort() {
        if (!result) return;
        result.className = 'rf-delivery-map__result is-miss';
        clearChildren(result);
        result.appendChild(el('span', { className: 'rf-delivery-map__result-name', text: 'Postal code too short' }));
        result.appendChild(el('div', { text: 'Enter at least the first 3 characters (e.g. M5V).' }));
        trackDelivery('rf_delivery_quote_result', {
          quote_status: 'input_too_short',
          zone_name: '',
          distance_bucket: '',
          fee_bucket: ''
        });
      }

      function renderError(msg) {
        if (!result) return;
        result.className = 'rf-delivery-map__result is-miss';
        clearChildren(result);
        result.appendChild(el('span', { className: 'rf-delivery-map__result-name', text: 'Could not get a live quote' }));
        result.appendChild(el('div', { text: msg || 'Showing zone estimate instead.' }));
        trackDelivery('rf_delivery_quote_result', {
          quote_status: 'error',
          zone_name: '',
          distance_bucket: '',
          fee_bucket: ''
        });
      }

      /*
        Optimistic two-stage render. Paint the zone's typical range
        instantly (so a number appears the moment you click or submit),
        then sharpen to the exact carrier quote when it returns. A failed
        quote simply leaves the instant estimate in place. Repeat lookups
        of the same address/point hit the in-memory cache and skip the
        network entirely. A monotonic token (lookupSeq) discards any quote
        that resolves after a newer lookup has started.
      */
      async function refineWithQuote(hintZone, cacheKey, fetchFn) {
        if (!result) return;
        var myseq = ++lookupSeq;
        renderZoneFallback(hintZone, { refining: true });
        trackDelivery('rf_delivery_quote_request', {
          quote_status: 'request',
          zone_name: hintZone && hintZone.name || '',
          cache_hit: !!(cacheKey && quoteCache[cacheKey])
        });

        if (cacheKey && quoteCache[cacheKey]) {
          var cached = quoteCache[cacheKey];
          trackDelivery('rf_delivery_quote_cache_hit', {
            quote_status: cached && cached.out_of_zone ? 'cached_out_of_zone' : 'cached_quote',
            zone_name: hintZone && hintZone.name || ''
          });
          if (cached && cached.out_of_zone) renderZoneFallback(hintZone);
          else renderQuote(cached, hintZone);
          return;
        }

        if (submitBtn) submitBtn.disabled = true;
        try {
          var quote = await fetchFn();
          if (cacheKey) quoteCache[cacheKey] = quote;
          if (myseq !== lookupSeq) return; // superseded by a newer lookup
          // The carrier may still veto an undeliverable point (lake edge,
          // no civic number). Trust our zone over the carrier's veto.
          if (quote && quote.out_of_zone) renderZoneFallback(hintZone);
          else renderQuote(quote, hintZone);
        } catch (e) {
          if (myseq !== lookupSeq) return;
          console.warn('[rf-delivery-map] quote refine failed; keeping zone estimate', e);
          trackDelivery('rf_delivery_quote_api_error', {
            quote_status: 'api_error',
            zone_name: hintZone && hintZone.name || ''
          });
          renderZoneFallback(hintZone);
        } finally {
          if (myseq === lookupSeq && submitBtn) submitBtn.disabled = false;
        }
      }

      async function handlePostal(pc) {
        activeLookupMethod = 'postal_or_address';
        var fsa = normalizePostal(pc);
        if (fsa.length < 3) { renderTooShort(); return; }
        trackDelivery('rf_delivery_lookup_start', {
          lookup_method: activeLookupMethod,
          input_bucket: fsa.length >= 6 ? 'postal_full' : 'fsa_prefix'
        });
        var fallback = lookupZone(fsa, zones);
        // No FSA prefix matched any of our zones → we don't deliver there.
        // Skip the live-quote API — its coverage is wider than what we
        // operationally promise.
        if (!fallback) {
          trackDelivery('rf_delivery_lookup_no_zone', {
            lookup_method: activeLookupMethod,
            input_bucket: fsa.length >= 6 ? 'postal_full' : 'fsa_prefix'
          });
          renderMiss();
          return;
        }
        // Quote-on-request zones never call the live-quote API; a returned
        // price would contradict our "email for a quote" copy.
        if (isQuoteOnRequestZone(fallback)) { renderZoneFallback(fallback); return; }
        if (!quoteApiUrl) { renderZoneFallback(fallback); return; }
        var address = postalAsAddress(fsa);
        await refineWithQuote(fallback, 'a:' + address, function () {
          return fetchQuote(quoteApiUrl, { deliveryAddress: address });
        });
      }

      async function handleMapClick(latlng) {
        if (activeLookupMethod !== 'geolocation') activeLookupMethod = 'map_click';
        addOrMoveDropPin(latlng);

        /*
          Authoritative-zone logic — OUR zones decide coverage, not the
          live-quote API. The carrier's coverage radius is much wider than
          ours (Hamilton at 70 km gets a paid quote even though it's
          outside our 22 km GTA radius), and it sometimes refuses a point
          clearly inside our circle. Gate everything on OUR distance first.
        */
        var distKm = haversineKm(lat, lng, latlng.lat, latlng.lng);
        var largestRadius = sortedAsc.length ? sortedAsc[sortedAsc.length - 1].radius_km : 0;
        var clickedZone = zoneForDistance(distKm, sortedAsc);
        trackDelivery('rf_delivery_map_click', {
          distance_bucket: distanceBucket(distKm * 1000),
          zone_name: clickedZone && clickedZone.name || '',
          quote_status: distKm > largestRadius ? 'outside_radius' : 'inside_radius'
        });

        // Click is past our furthest zone — we don't deliver here, period.
        if (distKm > largestRadius) { renderMiss(distKm); return; }

        var hintZone = clickedZone;
        if (!hintZone) { renderMiss(distKm); return; }

        // "Quoted on request" zones (Outside the GTA) — no firm number.
        if (isQuoteOnRequestZone(hintZone)) { renderZoneFallback(hintZone); return; }
        if (!quoteApiUrl) { renderZoneFallback(hintZone); return; }

        /*
          Send raw coordinates to the proxy and let it reverse-geocode
          server-side. This keeps the slow public-geocoder hop off the
          browser's critical path — one storefront round trip instead of
          two — and lets the proxy cache geocodes and send a policy-
          compliant User-Agent.
        */
        var key = 'g:' + latlng.lat.toFixed(4) + ',' + latlng.lng.toFixed(4);
        await refineWithQuote(hintZone, key, function () {
          return fetchQuote(quoteApiUrl, { lat: latlng.lat, lng: latlng.lng });
        });
      }

      /*
        A zone is "quoted on request" when its rate doesn't promise a
        firm price (e.g. "Quoted on request", "Email for a quote").
        Detected by matching common phrases in the rate string — no
        need to add a separate schema flag.
      */
      function isQuoteOnRequestZone(zone) {
        if (!zone || !zone.rate) return false;
        var s = zone.rate.toLowerCase();
        return s.indexOf('quote') !== -1 || s.indexOf('email') !== -1 || s.indexOf('request') !== -1;
      }

      function addOrMoveDropPin(latlng) {
        if (!section._rfMap || !Leaflet) return;
        if (dropPin) {
          dropPin.setLatLng(latlng);
        } else {
          var icon = Leaflet.divIcon({
            className: 'rf-delivery-map__droppin-wrap',
            html: '<div class="rf-delivery-map__droppin">'
              + '<span class="rf-delivery-map__droppin-label">Delivery to here</span>'
              + '<svg class="rf-delivery-map__droppin-pin" width="32" height="42" viewBox="0 0 32 42" aria-hidden="true">'
              +   '<path d="M16 41S30 26 30 15.5A14 14 0 1 0 2 15.5C2 26 16 41 16 41Z" stroke="#fff" stroke-width="2"/>'
              +   '<circle cx="16" cy="15.5" r="5" fill="#fff"/>'
              + '</svg>'
              + '</div>',
            iconSize: [32, 42],
            iconAnchor: [16, 41]
          });
          dropPin = Leaflet.marker(latlng, { icon: icon }).addTo(section._rfMap);
        }
        /*
          Zoom in close to the dropped pin so the customer sees their
          exact target (street level). flyTo animates the pan+zoom; we
          never zoom OUT past the current view, so a customer who has
          already zoomed in stays put — Math.max keeps the closer of the
          two. Level 15 ≈ neighbourhood/street detail.
        */
        var closeZoom = Math.max(section._rfMap.getZoom(), 15);
        section._rfMap.flyTo(latlng, closeZoom, { duration: 0.6 });
      }

      function renderMap() {
        if (!Leaflet) return;

        var map = Leaflet.map(mapEl, {
          scrollWheelZoom: false,
          zoomControl: true,
          attributionControl: true
        }).setView([lat, lng], 10);

        Leaflet.tileLayer(TILE_URL, {
          attribution: TILE_ATTRIBUTION,
          subdomains: 'abcd',
          maxZoom: 19
        }).addTo(map);

        /*
          Large padding on the SVG renderer extends the canvas 200% beyond
          the viewport on every side. Without this, a 6km circle at zoom 15
          projects to ~1800px radius and Leaflet's default 10% padding clips
          the fill to nothing when the viewport is inside the circle.
        */
        var zoneRenderer = Leaflet.svg({ padding: 2 });

        var circles = {};
        sortedForRender.forEach(function (zone) {
          var c = Leaflet.circle([lat, lng], {
            radius: (zone.radius_km || 5) * 1000,
            color: zone.color || '#7a8a52',
            fillColor: zone.color || '#7a8a52',
            fillOpacity: 0.18,
            weight: 1.5,
            opacity: 0.7,
            renderer: zoneRenderer
          }).addTo(map);
          c.bindTooltip(zone.name + ' · ' + zone.rate, { sticky: true, direction: 'top' });
          circles[zone.name] = c;
        });

        var pinNode = el('div', { className: 'rf-delivery-map__pin', text: studioLabel });
        var icon = Leaflet.divIcon({
          className: 'rf-delivery-map__pin-wrap',
          html: pinNode.outerHTML,
          iconSize: null,
          iconAnchor: [60, 12]
        });
        Leaflet.marker([lat, lng], { icon: icon }).addTo(map);

        if (sortedForRender[0]) {
          var biggest = circles[sortedForRender[0].name];
          if (biggest) map.fitBounds(biggest.getBounds(), { padding: [20, 20] });
        }

        if (clickEnabled && quoteApiUrl) {
          map.on('click', function (e) { handleMapClick(e.latlng); });
        }

        /*
          On every zoom change: re-project + repaint all zone circles.
          setStyle() alone only updates SVG attributes — it does NOT
          recompute the projected path. At street-level zoom (14+) the
          circle radius can exceed 1 800 px and Leaflet's SVG clip rect
          silently drops the geometry unless redraw() is called.

          fillOpacity also scales with zoom: at overview the light fill
          gives spatial context; at street level the viewport sits entirely
          inside the circle (no border visible) so a stronger fill tint
          tells the user which zone covers their pin.
        */
        map.on('zoomend', function () {
          var z = map.getZoom();
          var w    = z >= 14 ? 2.5  : z >= 12 ? 2    : 1.5;
          var fill = z >= 14 ? 0.28 : z >= 12 ? 0.22 : 0.18;
          sortedForRender.forEach(function (zone) {
            var c = circles[zone.name];
            if (!c) return;
            c.setStyle({ weight: w, fillOpacity: fill });
            c.redraw(); // force full re-project so large circles don't drop off-screen
          });
        });

        mapEl.classList.add('is-ready');
        section._rfMap = map;
        section._rfCircles = circles;
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          handlePostal(input.value);
        });
      }

      /*
        Geolocation shortcut. Tap → browser asks for permission →
        if granted, feeds lat/lng into the existing handleMapClick
        flow (which already does haversine zone check + reverse-
        geocode + live Trexity quote + pin drop). If denied,
        unsupported, or times out, we surface a friendly error
        and the customer can fall back to typing their postal code.
      */
      var geoBtn = section.querySelector('[data-rf-pc-geo]');
      if (geoBtn && navigator.geolocation && quoteApiUrl) {
        geoBtn.addEventListener('click', function () {
          if (geoBtn.disabled) return;
          activeLookupMethod = 'geolocation';
          trackDelivery('rf_delivery_geo_click');
          geoBtn.disabled = true;
          var originalText = geoBtn.querySelector('span').textContent;
          geoBtn.querySelector('span').textContent = 'Finding you…';
          navigator.geolocation.getCurrentPosition(
            function (position) {
              trackDelivery('rf_delivery_geo_success');
              geoBtn.disabled = false;
              geoBtn.querySelector('span').textContent = originalText;
              handleMapClick({
                lat: position.coords.latitude,
                lng: position.coords.longitude
              });
              // Pan map to the user's location for visual confirmation
              if (section._rfMap) {
                section._rfMap.setView([position.coords.latitude, position.coords.longitude], 13);
              }
            },
            function (err) {
              trackDelivery(err.code === err.PERMISSION_DENIED ? 'rf_delivery_geo_denied' : 'rf_delivery_geo_error');
              geoBtn.disabled = false;
              geoBtn.querySelector('span').textContent = originalText;
              renderError(
                err.code === err.PERMISSION_DENIED
                  ? 'Location permission denied — type your postal code instead.'
                  : 'Could not get your location — type your postal code instead.'
              );
            },
            { timeout: 8000, maximumAge: 60000, enableHighAccuracy: false }
          );
        });
      } else if (geoBtn && (!navigator.geolocation || !quoteApiUrl)) {
        // Geolocation API absent or proxy not configured — hide the button cleanly
        geoBtn.style.display = 'none';
      }

      loadLeaflet(renderMap);
    }

    function init() {
      document.querySelectorAll('.rf-delivery-map').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector ? e.target.querySelector('.rf-delivery-map') : null;
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-editorial-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rf-cat-carousel]').forEach(function (sec) {
      var track = sec.querySelector('[data-rf-cat-track]');
      var prev = sec.querySelector('[data-rf-cat-prev]');
      var next = sec.querySelector('[data-rf-cat-next]');
      if (!track) return;

      /*
        Compute step size = first card's width + the gap. We read the
        gap from computed style so it stays in sync with the CSS.
      */
      function getStep() {
        var card = track.querySelector('.rf-editorial-grid__card');
        if (!card) return 320;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16);
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.classList.toggle('is-disabled', track.scrollLeft <= 0);
        next.classList.toggle('is-disabled', track.scrollLeft >= max);
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rf-faq-search]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-rf-faq-search-input]');
      var count = wrap.querySelector('[data-rf-faq-search-count]');
      var root = wrap.parentElement;
      if (!input || !root) return;
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-rf-faq-item]'));
      var empty = root.querySelector('[data-rf-faq-empty]');
      var total = items.length;
      // Cache original state
      var cache = items.map(function (el) {
        var q = el.querySelector('[data-rf-faq-q]');
        var a = el.querySelector('[data-rf-faq-a]');
        return {
          el: el,
          wasOpen: el.hasAttribute('open'),
          text: ((q ? q.textContent : '') + ' ' + (a ? a.textContent : '')).toLowerCase()
        };
      });

      function reset() {
        cache.forEach(function (c) {
          c.el.classList.remove('is-hidden');
          if (c.wasOpen) c.el.setAttribute('open', ''); else c.el.removeAttribute('open');
        });
        if (count) count.textContent = '';
        if (empty) empty.hidden = true;
      }

      function run(q) {
        q = (q || '').trim().toLowerCase();
        if (!q) { reset(); return; }
        var matches = 0;
        cache.forEach(function (c) {
          var hit = c.text.indexOf(q) !== -1;
          if (hit) {
            c.el.classList.remove('is-hidden');
            c.el.setAttribute('open', '');
            matches++;
          } else {
            c.el.classList.add('is-hidden');
            c.el.removeAttribute('open');
          }
        });
        if (count) count.textContent = matches ? (matches + ' of ' + total + ' matches') : 'No matches';
        if (empty) empty.hidden = matches !== 0;
      }

      var t;
      input.addEventListener('input', function (e) {
        clearTimeout(t);
        var v = e.target.value;
        t = setTimeout(function () { run(v); }, 80);
      });
      input.addEventListener('search', function (e) { run(e.target.value); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { input.value = ''; reset(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-flower-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NOTE_KEY = 'rf-finder-gift-note';

    function el(tag, opts) {
      var node = document.createElement(tag);
      if (!opts) return node;
      if (opts.className) node.className = opts.className;
      if (opts.text != null) node.textContent = opts.text;
      if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { node.setAttribute(k, opts.attrs[k]); });
      if (opts.children) opts.children.forEach(function (c) { if (c) node.appendChild(c); });
      return node;
    }

    function clearChildren(node) { while (node.firstChild) node.removeChild(node.firstChild); }

    function formatPrice(cents, currency) {
      try {
        return new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency || 'CAD' }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function score(product, state) {
      var maxCents = state.budget * 100;
      if (product.price_cents > maxCents) return -1;
      if (state.color) {
        var colorTag = state.colorPrefix + state.color;
        if (!product.tags || product.tags.indexOf(colorTag) === -1) return -1;
      }
      if (state.form) {
        var formTag = state.formPrefix + state.form;
        if (!product.tags || product.tags.indexOf(formTag) === -1) return -1;
      }
      // Closeness: smaller (budget - price) is better; ties broken by availability
      var diff = maxCents - product.price_cents;
      return (product.available ? 1000000 : 0) - diff;
    }

    function renderResults(state, products, resultsEl, countEl, emptyEl, currency) {
      var matched = products
        .map(function (p) { return { p: p, s: score(p, state) }; })
        .filter(function (x) { return x.s >= 0; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, state.resultCount);

      countEl.textContent = matched.length;
      clearChildren(resultsEl);

      if (matched.length === 0) {
        var msg = el('p', {
          className: 'rf-finder__empty',
          text: 'No exact matches — try a higher budget or "Any" colour.'
        });
        resultsEl.appendChild(msg);
        return;
      }

      /*
        Render finder match cards using the SAME class names and
        markup structure as snippets/rf-product-card.liquid. Two
        wins from this:
          (a) Visual consistency — finder cards now look identical
              to collection-grid cards (same Quick View pill, same
              hover behaviours, same typography).
          (b) Single source of truth — any future styling update
              to rf-product-card automatically flows through here
              without a second CSS file to maintain.

        The markup mirror is exact: <article.rf-product-card> →
        <div.rf-product-card__image-wrap> wrapping the image anchor
        + the Quick View button (button OUTSIDE the anchor so its
        click doesn't navigate). Then <div.rf-product-card__info>
        with the title and price.
      */
      matched.forEach(function (m) {
        var p = m.p;
        var tagsLc = Array.isArray(p.tags) ? p.tags.map(function (tag) {
          return String(tag || '').toLowerCase();
        }) : [];
        var onSale = Math.max(0, (p.compare_at_price_max_cents || 0) - (p.price_cents || 0));
        var isBestSeller = tagsLc.indexOf('bestseller') !== -1 || tagsLc.indexOf('best seller') !== -1;
        var isSameDay = tagsLc.indexOf('same-day') !== -1;
        var article = el('article', {
          className: 'rf-product-card' + (p.available ? '' : ' rf-product-card--sold-out'),
          attrs: { 'data-rf-product-handle': p.handle || '' }
        });

        var imageWrap = el('div', { className: 'rf-product-card__image-wrap' });
        var imageAnchor = el('a', {
          className: 'rf-product-card__image',
          attrs: { href: p.url }
        });
        if (p.image) {
          imageAnchor.appendChild(el('img', {
            className: 'rf-product-card__img rf-product-card__img--primary',
            attrs: { src: p.image, alt: p.title, loading: 'lazy' }
          }));
        }
        if (p.hover_image) {
          imageAnchor.appendChild(el('img', {
            className: 'rf-product-card__img rf-product-card__img--hover',
            attrs: { src: p.hover_image, alt: '', loading: 'lazy', 'aria-hidden': 'true' }
          }));
        }

        var badges = el('div', { className: 'rf-product-card__badges' });
        if (!p.available) {
          badges.appendChild(el('span', {
            className: 'rf-product-card__badge rf-product-card__badge--soldout',
            text: 'Sold out'
          }));
        } else {
          if (onSale > 0) {
            badges.appendChild(el('span', {
              className: 'rf-product-card__badge rf-product-card__badge--sale',
              text: 'Sale'
            }));
          }
          if (isBestSeller) {
            badges.appendChild(el('span', {
              className: 'rf-product-card__badge rf-product-card__badge--best',
              text: 'Best Seller'
            }));
          }
          if (isSameDay) {
            badges.appendChild(el('span', {
              className: 'rf-product-card__badge rf-product-card__badge--same-day',
              text: 'Same-day'
            }));
          }
        }
        imageAnchor.appendChild(badges);
        imageWrap.appendChild(imageAnchor);

        if (p.handle && p.available) {
          imageWrap.appendChild(el('button', {
            className: 'rf-product-card__quick',
            text: 'Quick View',
            attrs: {
              type: 'button',
              'data-rf-quick-view': p.handle,
              'aria-label': 'Quick view ' + p.title
            }
          }));
        }

        article.appendChild(imageWrap);

        var info = el('div', { className: 'rf-product-card__info' });
        var title = el('h3', { className: 'rf-product-card__name' });
        title.appendChild(el('a', {
          text: p.title,
          attrs: { href: p.url }
        }));
        info.appendChild(title);
        if (p.type) {
          info.appendChild(el('p', {
            className: 'rf-product-card__format',
            text: p.type
          }));
        }
        var meta = el('div', { className: 'rf-product-card__meta' });
        var price = el('span', { className: 'rf-product-card__price' });
        if (p.price_varies) {
          price.appendChild(el('span', {
            className: 'rf-product-card__price-from',
            text: 'From'
          }));
          price.appendChild(document.createTextNode(formatPrice(p.price_min_cents || p.price_cents, currency)));
        } else {
          price.appendChild(document.createTextNode(formatPrice(p.price_cents, currency)));
          if (onSale > 0) {
            price.appendChild(el('s', {
              className: 'rf-product-card__price-compare',
              text: formatPrice(p.compare_at_price_max_cents, currency)
            }));
          }
        }
        meta.appendChild(price);
        if (p.available && p.variant_id) {
          var atcForm = el('form', {
            className: 'rf-product-card__atc-form',
            attrs: { action: '/cart/add', method: 'post', enctype: 'multipart/form-data' }
          });
          atcForm.appendChild(el('input', {
            attrs: { type: 'hidden', name: 'id', value: String(p.variant_id) }
          }));
          atcForm.appendChild(el('button', {
            className: 'rf-product-card__atc',
            text: 'Add',
            attrs: { type: 'submit', 'aria-label': 'Add ' + p.title + ' to cart' }
          }));
          meta.appendChild(atcForm);
        }
        info.appendChild(meta);

        article.appendChild(info);
        resultsEl.appendChild(article);
      });
    }

    function readUrlParams() {
      try {
        var qs = new URLSearchParams(window.location.search);
        return {
          budget: qs.get('budget'),
          color: qs.get('color'),
          form: qs.get('form')
        };
      } catch (e) {
        return { budget: null, color: null, form: null };
      }
    }

    /*
      Build the "See all matches →" link to land the customer on the
      shop page (default /collections/shop-all) with their finder
      selections already converted to Shopify's native filter URL
      params. The collection page's Quick Filter chips read the
      same params and highlight automatically, so the experience
      continues seamlessly:

        Finder slider $80, Pink, Hand-tied
          → /collections/shop-all?filter.v.price.lte=80
                            &filter.p.tag=color-pink
                            &filter.p.tag=form-hand-tied
          → Shop page loads, "Pink" + "Hand-tied" chips highlighted,
            price filter applied, full result grid shown.

      Backward compatible: if the merchant has set `more_link` to
      a non-shop URL (e.g. the dedicated /pages/flower-finder), we
      fall back to the legacy `?budget=&color=&form=` params for
      that page.
    */
    function buildMoreHref(base, state, config) {
      if (!base) return '';
      var isShopRoute = /\/collections\//.test(base);
      var params = [];
      if (isShopRoute) {
        // Shop-page native filter params
        if (state.budget) params.push('filter.v.price.lte=' + encodeURIComponent(state.budget));
        if (state.color) {
          var colorPrefix = (config && config.color_prefix) || 'color-';
          params.push('filter.p.tag=' + encodeURIComponent(colorPrefix + state.color));
        }
        if (state.form) {
          var formPrefix = (config && config.form_prefix) || 'form-';
          params.push('filter.p.tag=' + encodeURIComponent(formPrefix + state.form));
        }
      } else {
        // Legacy: finder's own page reads simple params
        if (state.budget) params.push('budget=' + encodeURIComponent(state.budget));
        if (state.color) params.push('color=' + encodeURIComponent(state.color));
        if (state.form) params.push('form=' + encodeURIComponent(state.form));
      }
      if (!params.length) return base;
      return base + (base.indexOf('?') >= 0 ? '&' : '?') + params.join('&');
    }

    function initSection(section) {
      var productsScript = section.querySelector('[data-rf-finder-products]');
      var configScript = section.querySelector('[data-rf-finder-config]');
      var resultsEl = section.querySelector('[data-rf-results]');
      var countEl = section.querySelector('[data-rf-results-count]');
      var emptyEl = section.querySelector('[data-rf-empty]');
      var noteEl = section.querySelector('[data-rf-note]');
      var noteStatus = section.querySelector('[data-rf-note-status]');
      var budgetInput = section.querySelector('[data-rf-budget]');
      var budgetOuts = section.querySelectorAll('[data-rf-budget-out]');
      var colorButtons = section.querySelectorAll('[data-rf-color]');
      var formButtons = section.querySelectorAll('[data-rf-form]');
      var moreLink = section.querySelector('[data-rf-more]');

      if (!productsScript || !configScript || !resultsEl) return;

      var products = [];
      var config = {};
      try {
        products = JSON.parse(productsScript.textContent || '[]');
        config = JSON.parse(configScript.textContent || '{}');
      } catch (e) {
        console.warn('[rf-finder] Could not parse JSON', e);
        return;
      }

      var state = {
        budget: parseInt(budgetInput.value, 10) || 100,
        color: '',
        form: '',
        colorPrefix: config.color_prefix || 'color-',
        formPrefix: config.form_prefix || 'form-',
        resultCount: config.result_count || 6
      };

      // Apply URL params on init — pre-fills the form when arriving from the
      // homepage compact teaser via "More suggestions →".
      var urlParams = readUrlParams();
      if (urlParams.budget) {
        var bv = parseInt(urlParams.budget, 10);
        if (!isNaN(bv) && bv > 0) {
          state.budget = bv;
          if (budgetInput) budgetInput.value = bv;
        }
      }
      if (urlParams.color) state.color = urlParams.color;
      if (urlParams.form) state.form = urlParams.form;

      function syncButtonStates() {
        colorButtons.forEach(function (b) {
          var on = (b.dataset.rfColor || '') === state.color;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        formButtons.forEach(function (b) {
          var on = (b.dataset.rfForm || '') === state.form;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      function updateBudgetOuts() {
        budgetOuts.forEach(function (o) { o.textContent = '$' + state.budget; });
      }

      function updateMoreHref() {
        if (!moreLink) return;
        moreLink.setAttribute('href', buildMoreHref(config.more_link || '/collections/shop-all', state, config));
      }

      function update() {
        renderResults(state, products, resultsEl, countEl, emptyEl, config.currency || 'CAD');
        updateMoreHref();
      }

      budgetInput.addEventListener('input', function () {
        state.budget = parseInt(budgetInput.value, 10) || 0;
        updateBudgetOuts();
        update();
      });

      colorButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          colorButtons.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          state.color = btn.dataset.rfColor || '';
          update();
        });
      });

      formButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          formButtons.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          state.form = btn.dataset.rfForm || '';
          update();
        });
      });

      // Reflect URL-derived state in the UI now that handlers are wired up.
      syncButtonStates();

      // Persist gift note to localStorage so cart page can pick it up.
      try {
        var saved = localStorage.getItem(NOTE_KEY);
        if (saved && noteEl) noteEl.value = saved;
      } catch (e) {}

      if (noteEl) {
        var saveTimer;
        noteEl.addEventListener('input', function () {
          if (saveTimer) clearTimeout(saveTimer);
          saveTimer = setTimeout(function () {
            try {
              if (noteEl.value) {
                localStorage.setItem(NOTE_KEY, noteEl.value);
                if (noteStatus) noteStatus.textContent = 'Saved — paste this into the cart’s gift-note field at checkout.';
              } else {
                localStorage.removeItem(NOTE_KEY);
                if (noteStatus) noteStatus.textContent = '';
              }
            } catch (e) {}
          }, 400);
        });
      }

      updateBudgetOuts();
      update();
    }

    function init() {
      document.querySelectorAll('.rf-finder').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector ? e.target.querySelector('.rf-finder') : null;
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Hero carousel — auto-advance cross-fade between slides. Pauses
    on hover/focus, respects prefers-reduced-motion (manual-only
    mode for those users). Manual dots provide jump-to-slide.
  */
  (function () {
    var heroes = document.querySelectorAll('[data-rf-hero-carousel]');
    heroes.forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-rf-hero-slide]');
      var dots = hero.querySelectorAll('[data-rf-hero-dot]');
      /*
        Note: we DON'T early-return for single-slide heroes anymore.
        Adaptive color detection should run on the first slide even
        when there's just one. The carousel-specific logic below
        (dots, autoplay, slide-cycling) is gated separately by
        `if (slides.length > 1)`.
      */
      if (!slides.length) return;
      var current = 0;
      var timer = null;
      var intervalMs = parseInt(hero.getAttribute('data-interval-ms'), 10) || 6000;
      var autoplay = hero.getAttribute('data-autoplay') !== 'false';
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var content = hero.querySelector('.rf-hero__content');

      /*
        ADAPTIVE TEXT COLOR — sample the bottom-right quadrant of the
        active slide's image and swap text color based on its
        luminance. Uses a FRESH probe Image with `crossOrigin =
        "anonymous"` rather than reusing the in-DOM <img>, because
        browsers may have cached the original load without CORS
        headers, which makes canvas getImageData() throw a
        SecurityError. A new probe with the CORS attribute set
        FORCES the browser to redo the fetch (or use a CORS-allowed
        cached entry), eliminating the cache mismatch.

        Threshold 0.5 (middle gray) — luminance above means light
        backdrop, switch to dark text; below means dark backdrop,
        keep cream text. Cache per slide index so we only probe
        each image once per session.

        Console-logs the detected luminance so the merchant can
        verify in DevTools that the detection is running.
      */
      /*
        Per-slide luminance cache holds an object of two values:
          { hero: <bottom-right lum>, menu: <top-strip lum> }
        Two distinct sample zones because the hero text and the menu
        bar sit on DIFFERENT parts of the same photo:
          - Hero text card is bottom-right    → sample (50,50)→(100,100)
          - Menu bar overlays the very top    → sample (0,0)→(100,25)
        Using a single global luminance for both made the menu flip
        based on the wrong area (e.g. dark sky at top, bright flowers
        at bottom → menu went dark on a dark backdrop).
      */
      var luminanceCache = {};
      // TEMP ("keep this dark for now" = dark TEXT): force the dark-text
      // treatment (.is-on-light → charcoal heading) instead of letting the
      // sampler pick cream on these pale photos. Set to false to restore
      // automatic light/dark sampling once a hero image is in place.
      var RF_HERO_FORCE_DARK_TEXT = true;
      function broadcastBrightness(heroLum, menuLum) {
        var heroIsLight = RF_HERO_FORCE_DARK_TEXT ? true : (heroLum > 0.5);
        var menuIsLight = RF_HERO_FORCE_DARK_TEXT ? true : (menuLum > 0.5);
        if (content) content.classList.toggle('is-on-light', heroIsLight);
        document.body.setAttribute('data-rf-hero-bright', heroIsLight ? 'true' : 'false');
        // Separate signal just for the menu (header reads this attribute).
        document.body.setAttribute('data-rf-hero-top-bright', menuIsLight ? 'true' : 'false');
      }
      function avgLuminance(data) {
        var r = 0, g = 0, b = 0, n = data.length / 4;
        for (var i = 0; i < data.length; i += 4) {
          r += data[i]; g += data[i + 1]; b += data[i + 2];
        }
        return (0.299 * (r / n) + 0.587 * (g / n) + 0.114 * (b / n)) / 255;
      }
      /*
        Idle-time scheduler for the canvas sampling below. drawImage +
        getImageData block the main thread ~5-10ms per uncached slide,
        and applyAdaptiveColor fires on EVERY slide change — running
        the sampling during browser idle periods keeps the cross-fade
        transition (and any in-progress scroll) jank-free. Browsers
        without requestIdleCallback fall back to a 100ms setTimeout:
        late enough to clear the transition's first frames, early
        enough that the text-color swap still feels immediate.
      */
      function whenIdle(fn) {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(fn);
        } else {
          setTimeout(fn, 100);
        }
      }
      function applyAdaptiveColor(idx) {
        if (!content) return;
        if (luminanceCache[idx] !== undefined) {
          // Cached path — re-broadcast both signals
          var c = luminanceCache[idx];
          broadcastBrightness(c.hero, c.menu);
          return;
        }
        var slideImg = slides[idx] && slides[idx].querySelector('img');
        if (!slideImg) return;
        var src = slideImg.currentSrc || slideImg.src;
        if (!src) return;

        var probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.onload = function () {
          /*
            Defer the expensive canvas work (drawImage + getImageData)
            to browser idle time so it never lands inside the slide
            cross-fade's animation frames. Everything inside — the
            sampling, the per-slide luminance cache write, and the
            broadcast — is byte-for-byte the same logic; only WHEN it
            runs moves off the slide-change critical path. The cached
            path above stays synchronous, so revisited slides still
            re-broadcast instantly.
          */
          whenIdle(function () {
            try {
              var canvas = document.createElement('canvas');
              canvas.width = 100;
              canvas.height = 100;
              var ctx = canvas.getContext('2d');
              ctx.drawImage(probe, 0, 0, canvas.width, canvas.height);
              // Two samples: top strip (menu zone) + bottom-right (hero text zone)
              var menuData = ctx.getImageData(0, 0, 100, 25).data;
              var heroData = ctx.getImageData(50, 50, 50, 50).data;
              var menuLum = avgLuminance(menuData);
              var heroLum = avgLuminance(heroData);
              luminanceCache[idx] = { hero: heroLum, menu: menuLum };
              broadcastBrightness(heroLum, menuLum);
              if (window.console) {
                console.log(
                  '[rf-hero] slide ' + idx +
                  ' | menu-top lum=' + menuLum.toFixed(3) + ' → ' + (menuLum > 0.5 ? 'dark menu' : 'cream menu') +
                  ' | hero-br lum=' + heroLum.toFixed(3) + ' → ' + (heroLum > 0.5 ? 'dark hero' : 'cream hero')
                );
              }
            } catch (e) {
              // CORS-tainted canvas: fall back to the forced state if set,
              // otherwise the original cream default.
              luminanceCache[idx] = { hero: RF_HERO_FORCE_DARK_TEXT ? 1 : 0, menu: RF_HERO_FORCE_DARK_TEXT ? 1 : 0 };
              if (RF_HERO_FORCE_DARK_TEXT) {
                broadcastBrightness(1, 1);
              } else {
                content.classList.remove('is-on-light');
                document.body.removeAttribute('data-rf-hero-bright');
                document.body.removeAttribute('data-rf-hero-top-bright');
              }
              if (window.console) {
                console.warn('[rf-hero] canvas sample failed for slide ' + idx + ':', e.message);
              }
            }
          });
        };
        probe.onerror = function () {
          luminanceCache[idx] = { hero: 0, menu: 0 };
          if (window.console) {
            console.warn('[rf-hero] probe image failed to load for slide ' + idx);
          }
        };
        probe.src = src;
      }
      // Run for the initial active slide. Wait a tick so the in-DOM
      // image has time to resolve currentSrc via srcset. This runs
      // for ANY hero (1 slide or more) — single-slide heroes still
      // get adaptive color detection.
      setTimeout(function () { applyAdaptiveColor(current); }, 50);

      // The carousel-specific logic below (dot navigation, autoplay,
      // pointer-pause) only makes sense with multiple slides.
      if (slides.length <= 1) return;

      function show(idx) {
        if (idx === current) return;
        slides.forEach(function (s, i) {
          var on = i === idx;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          var on = i === idx;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        current = idx;
        applyAdaptiveColor(idx);
      }

      function next() { show((current + 1) % slides.length); }

      function start() {
        if (!autoplay || reducedMotion) return;
        stop();
        timer = setInterval(next, intervalMs);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          /*
            Slides 2+ ship with loading="lazy", and a hidden
            opacity-0 cross-fade slide may not trigger the browser's
            lazy-load heuristics until it's already visible. The dot
            click is an unambiguous signal of intent — bump the
            target slide's <img> to eager BEFORE the cross-fade
            starts so the network fetch begins immediately instead
            of after the fade reveals an empty slide.
          */
          var slideImg = slides[i] && slides[i].querySelector('img');
          if (slideImg && slideImg.getAttribute('loading') === 'lazy') {
            slideImg.setAttribute('loading', 'eager');
          }
          show(i);
          stop();
          start(); // restart timer after manual selection
        });
      });

      hero.addEventListener('pointerenter', stop);
      hero.addEventListener('pointerleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      start();
    });
  })();

  /*
    Live delivery-window badge (same-day cutoff awareness).
    Separate IIFE so it doesn't bail out the carousel on pages
    without the delivery badge (early-return bug in the prior version).
  */
  (function () {
    var badges = document.querySelectorAll('[data-rf-hero-delivery]');
    if (!badges.length) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function update(badge) {
      var cutH = parseInt(badge.getAttribute('data-cutoff-hour'), 10);
      var cutM = parseInt(badge.getAttribute('data-cutoff-minute'), 10);
      var openH = parseInt(badge.getAttribute('data-open-hour'), 10);
      var closeH = parseInt(badge.getAttribute('data-close-hour'), 10);
      if (isNaN(cutH)) cutH = 15;
      if (isNaN(cutM)) cutM = 30;
      if (isNaN(openH)) openH = 12;
      if (isNaN(closeH)) closeH = 18;

      var now = new Date();
      var h = now.getHours();
      var m = now.getMinutes();
      var textEl = badge.querySelector('.rf-hero__delivery-text');
      if (!textEl) return;

      badge.classList.remove('is-open', 'is-late', 'is-closed', 'is-pending');

      var beforeOpen = h < openH;
      var afterClose = h >= closeH;

      if (beforeOpen || afterClose) {
        badge.classList.add('is-closed');
        if (beforeOpen) {
          textEl.textContent = 'Opens at ' + (openH === 12 ? 'noon' : pad(openH) + ':00');
        } else {
          textEl.textContent = 'Closed · Opens ' + (openH === 12 ? 'tomorrow at noon' : 'tomorrow ' + pad(openH) + ':00');
        }
        return;
      }

      // Open hours. Compare against cutoff.
      var minutesNow = h * 60 + m;
      var minutesCut = cutH * 60 + cutM;

      if (minutesNow < minutesCut) {
        var diff = minutesCut - minutesNow;
        var hh = Math.floor(diff / 60);
        var mm = diff % 60;
        var left = (hh > 0 ? hh + 'h ' : '') + mm + 'm';
        badge.classList.add('is-open');
        textEl.textContent = 'Same-day delivery · Order within ' + left;
      } else {
        badge.classList.add('is-late');
        textEl.textContent = 'Next same-day: tomorrow';
      }
    }

    function tickAll() {
      badges.forEach(function (b) { update(b); });
    }

    tickAll();
    setInterval(tickAll, 60000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Gate WYSIWYG unveil + stamp animations on the main image being ready.
    // Fires via load event for slow connections; falls back to immediate
    // for cached images (complete + naturalWidth > 0).
    var wysMainBox = document.querySelector('.rf-pdp__main-image--wys');
    if (wysMainBox) {
      var wysImg = wysMainBox.querySelector('img');
      function triggerWysAnimations() {
        wysMainBox.classList.add('is-img-loaded');
      }
      if (wysImg) {
        if (wysImg.complete && wysImg.naturalWidth > 0) {
          triggerWysAnimations();
        } else {
          wysImg.addEventListener('load', triggerWysAnimations, { once: true });
          wysImg.addEventListener('error', triggerWysAnimations, { once: true });
        }
      }
    }

    // Thumbnail → main image swap
    //
    // Subtle bug we hit: the main <img> is rendered by Shopify's
    // `image_tag` filter with `widths: '600, 900, 1200'`, which emits
    // BOTH `src` and `srcset`. Setting `.src` alone leaves `srcset`
    // pointing at the original image, and `srcset` wins — so clicks
    // appeared to do nothing. Fix: rebuild `srcset` for the new image
    // (Shopify CDN URLs put width in a `?width=` query param, so a
    // regex swap gives us all three responsive variants in one line)
    // and update `src` as a fallback for browsers that ignore srcset.
    /*
      Customer feedback: tapping a thumbnail "takes a long time to
      load." Root cause: previous swap set `src`+`srcset` directly,
      so the browser only STARTED downloading the new image on
      click — and the visible <img> stayed showing the old picture
      until the new file finished arriving. On 4G that's 1-3s of
      "did anything happen?"

      Fix: preload the new image via `new Image()` in the
      background. As soon as the bytes are in the browser cache,
      we set `srcset`+`src` — the swap is then instant (the
      browser uses the cached resource). For repeat clicks on the
      same product, every swap after the first is INSTANT because
      every image we set is already cached.

      Bonus: thumbnails preload their hi-res versions when the
      page becomes idle, so even the FIRST tap on a thumb feels
      instant if the user idled for >1s before clicking.
    */
    function buildSrcset(src) {
      var src600  = src.replace(/width=\d+/, 'width=600');
      var src900  = src.replace(/width=\d+/, 'width=900');
      var src1200 = src.replace(/width=\d+/, 'width=1200');
      return {
        src1200: src1200,
        set: src600 + ' 600w, ' + src900 + ' 900w, ' + src1200 + ' 1200w'
      };
    }
    document.querySelectorAll('[data-rf-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        var main = btn.closest('.rf-pdp__gallery').querySelector('.rf-pdp__main-image img');
        var thumbs = btn.closest('.rf-pdp__thumbs');
        if (main && src) {
          var s = buildSrcset(src);
          // Brief opacity dim so the user knows something's happening,
          // even if the download is fast.
          main.style.transition = 'opacity 0.18s ease';
          main.style.opacity = '0.55';
          // Preload in background — only swap when bytes are ready.
          var preloader = new Image();
          preloader.onload = function () {
            main.srcset = s.set;
            main.src = s.src1200;
            main.style.opacity = '1';
          };
          preloader.onerror = function () {
            // If preload fails (network), swap anyway and let the
            // browser show whatever it can.
            main.srcset = s.set;
            main.src = s.src1200;
            main.style.opacity = '1';
          };
          preloader.src = s.src1200;
        }
        if (thumbs) {
          thumbs.querySelectorAll('.rf-pdp__thumb').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        }
      });
    });
    // Idle-time preload of every thumbnail's full-size image so
    // subsequent clicks are instant. Uses requestIdleCallback when
    // available; falls back to a 1.5s setTimeout otherwise.
    function idlePreloadThumbs() {
      document.querySelectorAll('[data-rf-thumb]').forEach(function (btn) {
        var src = btn.dataset.src;
        if (!src) return;
        var img = new Image();
        img.src = src.replace(/width=\d+/, 'width=600');
      });
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(idlePreloadThumbs, { timeout: 3000 });
    } else {
      setTimeout(idlePreloadThumbs, 1500);
    }

    /*
      Variant picker — real selection logic.

      BUG HISTORY: this used to ONLY toggle the `is-active` class on
      option buttons and trust "form submit will figure out the
      variant". That trust was misplaced — Shopify's product form
      doesn't auto-resolve variants from option labels, it submits
      whatever's in <input name="id">. So clicking "Premium" updated
      the visual state but the hidden ID stayed on Standard's value,
      and customers got Standard at Standard's price even when they
      selected Premium (Standard $95 / Premium $145 — a $50 spread
      that silently lost revenue).

      FIX: on every option click, collect the currently-active value
      from EACH option group, build the option tuple, find the
      matching variant in our pre-rendered JSON island, and:
       (a) update the hidden ID input — what actually gets POSTed
       (b) update the visible price in .rf-pdp__price-current + ATC
       (c) toggle ATC's disabled + label based on variant.available

      Compare-at price + sale badge are intentionally left static
      (set from `featured` at server render) — if a product has
      sale variants with different compare-at structures, that needs
      its own pass.
    */
    (function () {
      var variantsScript = document.querySelector('[data-rf-variants]');
      if (!variantsScript) return;
      var variants;
      try { variants = JSON.parse(variantsScript.textContent || '[]'); }
      catch (e) { return; }

      var hiddenIdInput = document.querySelector('[data-rf-variant-id]');
      var atc = document.querySelector('.rf-pdp__atc');
      var priceEl = document.querySelector('.rf-pdp__price-current');

      function formatMoney(cents) {
        // Mirror Shopify's default money format: "$95.00".
        // If the merchant switches store currency this still produces
        // a readable string — formal i18n can be layered later.
        return '$' + (cents / 100).toFixed(2);
      }

      function activeOptionValues() {
        var values = [];
        document.querySelectorAll('.rf-pdp__option').forEach(function (group) {
          var active = group.querySelector('[data-rf-option].is-active');
          if (active) values.push(active.dataset.rfValue);
        });
        return values;
      }

      function findMatchingVariant(values) {
        return variants.find(function (v) {
          if (!v.options || v.options.length !== values.length) return false;
          for (var i = 0; i < values.length; i++) {
            if (v.options[i] !== values[i]) return false;
          }
          return true;
        });
      }

      function applyVariant(variant) {
        if (!variant) return;
        if (hiddenIdInput) hiddenIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (atc) {
          if (variant.available) {
            atc.disabled = false;
            atc.textContent = 'Add to cart — ' + formatMoney(variant.price);
          } else {
            atc.disabled = true;
            atc.textContent = 'Sold out';
          }
        }
      }

      document.querySelectorAll('[data-rf-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = btn.dataset.rfOption;
          // Visual toggle within the same option group
          btn.parentElement.querySelectorAll('[data-rf-option="' + pos + '"]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          // Resolve + apply matching variant
          applyVariant(findMatchingVariant(activeOptionValues()));
        });
      });
    })();

    // Qty +/-
    document.querySelectorAll('[data-rf-qty-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.rf-pdp__qty').querySelector('[data-rf-qty-input]');
        var v = parseInt(input.value || '1', 10) + parseInt(btn.dataset.rfQtyDir, 10);
        input.value = Math.max(1, Math.min(99, v));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.querySelector('[data-rf-recently]');
    if (!sec) return;
    var track = sec.querySelector('[data-rf-recently-track]');
    var currentHandle = sec.dataset.rfCurrentHandle;
    var KEY = 'rf:recently-viewed';
    var MAX = 6;

    function load() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function save(arr) {
      try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
    }
    function push(handle) {
      if (!handle) return;
      var arr = load().filter(function (h) { return h !== handle; });
      arr.unshift(handle);
      save(arr);
    }

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function renderItem(p) {
      // DOM construction (no innerHTML with untrusted data)
      var a = document.createElement('a');
      a.className = 'rf-recently__item';
      a.href = p.url || '/products/' + p.handle;

      var imgWrap = document.createElement('span');
      imgWrap.className = 'rf-recently__item-image';
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image;
        img.alt = p.title || '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      a.appendChild(imgWrap);

      var name = document.createElement('span');
      name.className = 'rf-recently__item-name';
      name.textContent = p.title || '';
      a.appendChild(name);

      var price = document.createElement('span');
      price.className = 'rf-recently__item-price';
      price.textContent = money(p.price);
      a.appendChild(price);

      return a;
    }

    function render(handles) {
      // Exclude current product
      var targets = handles.filter(function (h) { return h !== currentHandle; }).slice(0, MAX);
      if (targets.length === 0) { sec.hidden = true; return; }

      Promise.all(targets.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(Boolean);
        if (valid.length === 0) { sec.hidden = true; return; }
        track.replaceChildren();
        valid.forEach(function (p) { track.appendChild(renderItem(p)); });
        sec.hidden = false;

        // Trigger carousel-wheel.js rescan + nav-arrow visibility update.
        // The track was empty when the carousel script first scanned the
        // page, so arrows weren't shown. Dispatching scroll + resize forces
        // updateNavVisibility() to recompute now that items exist.
        requestAnimationFrame(function () {
          track.dispatchEvent(new Event('scroll'));
          window.dispatchEvent(new Event('resize'));
        });
      });
    }

    // Record current product, then render the list
    if (currentHandle) push(currentHandle);
    render(load());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-wedding-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.body.classList.add('rf-hero-intro');
    document.querySelectorAll('.rf-page-hero [data-rf-hero-in]').forEach(function (el, i) {
      setTimeout(function () { el.classList.add('rf-in'); }, 150 + i * 130);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-workshop-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Thumbnail → main image swap
    document.querySelectorAll('[data-rf-wsp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        var main = btn.closest('.rf-wsp__gallery').querySelector('.rf-wsp__main-image img');
        if (main && src) main.src = src;
        btn.closest('.rf-wsp__thumbs').querySelectorAll('.rf-wsp__thumb').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    // Variant option pill UI — mirrors rf-pdp behaviour
    document.querySelectorAll('.rf-wsp [data-rf-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.dataset.rfOption;
        btn.parentElement.querySelectorAll('[data-rf-option="' + pos + '"]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    // Qty +/-
    document.querySelectorAll('.rf-wsp [data-rf-qty-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.rf-wsp__qty').querySelector('[data-rf-qty-input]');
        var v = parseInt(input.value || '1', 10) + parseInt(btn.dataset.rfQtyDir, 10);
        input.value = Math.max(1, Math.min(99, v));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
